<template>
  <div v-if="!$store.getters.translationsLoaded">
    <base-loader></base-loader>
  </div>
  <div v-else>
    <v-tabs fixed-tabs>
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        @click="loadDashboard(tab, index)"
      >{{ `${tab.tab} (${tab.subname})` }}</v-tab>
    </v-tabs>
    <v-container fluid>
      <component v-if="lastIndex === index" :is="currentTabComponent.name"></component>
    </v-container>
  </div>
</template>

<script>
import auth from '@/api/auth'
import myMixins from '@/mixins/generalMixin'
import { mapMutations } from 'vuex'
import BaseLoader from '../components/loaders/BaseLoader'

export default {
  name: 'BIdashboardMulti',
  components: {
    // active
    BaseLoader
  },
  mixins: [myMixins],
  data () {
    return {
      activeDashboard: {},
      tabs: [],
      lastIndex: 0,
      index: 0
    }
  },
  computed: {
    currentTabComponent: {
      cache: false,
      get () { return this.activeDashboard },
      set (val) { this.activeDashboard = val }
    }
  },
  created () {
    let self = this
    // TODO: refactor to be only on one component (App.vue)
    // set language from query param
    if (this.$route.query && this.$route.query.lang) {
      this.$log.info('Route query Language:', this.$route.query.lang)
      this.$store.commit('SET_LANGUAGE', this.$route.query.lang)
      this.$store.dispatch('fetchTranslations')
    } else {
      this.$store.commit('SET_LANGUAGE', 'en')
      this.$store.dispatch('fetchTranslations')
    }

    // set token from url
    this.$store.commit('SET_AUTH_TOKEN', this.$route.params.token)
    auth.setAuthToken(this.$route.params.token)
    // build component name
    let camelize = (text, separator = '-') => (
      text.split(separator)
        .map(w => w.replace(/./, m => m.toUpperCase()))
        .join('')
    )
    let platform = this.$route.params.platform
    let dashboard = this.$route.params.dashboard
    let list = [{
      name: dashboard,
      subname: 'create',
      modified: false
    }, {
      name: dashboard,
      subname: 'update',
      modified: true
    }]
    list.forEach(function (v) {
      let slug = camelize(v.name)
      let componentName = 'Dashboard' + slug
      self.tabs.push({
        name: 'active' + slug,
        subname: v.subname,
        modified: v.modified,
        tab: slug
      })
      // load component
      // on error display message
      self.$options.components['active' + slug] = () => import('@/components/dashboards/' + platform + '/' + componentName).catch((err) => ({
        render: h => h('div', [
          h('h1', 'Invalid dashboard: ' + v),
          h('p', err)
        ])
      }))
    })
    this.currentTabComponent = this.tabs[0]

    !this.currentTabComponent.modified
      ? this.setDateTimeParamName('')
      : this.setDateTimeParamName('date_time_modified')
  },
  destroyed () {
    this.setDateTimeParamName('')
  },
  methods: {
    ...mapMutations({
      setDateTimeParamName: 'GEN_SET_DATETIME_PARAM_NAME'
    }),
    loadDashboard (tab, index) {
      // reset store dashboard charts & filters states
      this.$store.commit('GEN_CLEAR_FILTERS')
      this.$store.commit('RESET_STATE')

      !tab.modified
        ? this.setDateTimeParamName('')
        : this.setDateTimeParamName('date_time_modified')

      // switch dashboard
      this.currentTabComponent = tab
      this.lastIndex = this.index
      this.index = index
      this.$nextTick(function () {
        this.lastIndex = index
      }.bind(this))
    }
  }
}
</script>

<style lang="scss">
  .v-tabs__item.v-tabs__item--active {
    pointer-events: none;
  }
</style>
